var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',{staticClass:"rcorners1"},[_c('span',{staticStyle:{"color":"white","font-size":"32pt"}},[_vm._t("default")],2)]),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }